(function($) {
    function loadMorePosts(e){
        var container = $('.main .posts-wrapper, .main .search-results');
        var loadMore = $(this);
        if(!container.isLoading()){
            container.addLoadingOverlay();
            loadMore.append('<i class="fa fa-spinner fa-pulse"></i>');
            $.get(loadMore.attr('href'), function(data){
                var url = loadMore.attr('href');
                var posts = $(data).find('.main article');
                var title = $(data).filter('title').text();
                history.pushState({urlPath: url},title, url);
                if(posts.length){
                    container.append(posts);
                }
                var nextPage = $(data).find('.main a.load-more');
                if(nextPage){
                    loadMore.replaceWith(nextPage);
                    nextPage.click(loadMorePosts);
                }
                else {
                    loadMore.remove();
                }
                container.removeLoadingOverlay();
            }).fail(function() {
                container.removeLoadingOverlay();
            });
        }
        e.preventDefault();
        return false;
    }

    $(document).ready(function($){
        
        // Load more posts
        $('a.load-more').click(loadMorePosts);
  
    });

})(jQuery);